var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoinGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8121 12.645C18.8121 11.1493 17.6519 9.98595 16.1602 9.98595V9.90286H15.9945V14.6392H16.0773C18.7293 14.6392 20.6353 16.3842 20.6353 18.8771C20.6353 21.3699 18.6464 23.198 16.0773 23.198H15.9116V25.0261H14.0055V23.198H13.9226C11.4365 23.198 9.36463 21.1206 9.36463 18.6278H11.3536C11.3536 20.1235 12.5138 21.2868 14.0055 21.2868H14.0884V16.5504H14.0055C11.3536 16.5504 9.4475 14.8054 9.4475 12.3126C9.4475 9.81976 11.4365 7.99169 14.0055 7.99169H14.0884V6.08051H15.9945V8.07477H16.1602C18.6464 8.07477 20.7182 10.1521 20.7182 12.645H18.8121ZM11.3536 12.3126C11.3536 13.8914 12.6795 14.6392 14.0055 14.6392H14.0884V9.90286H14.0055C12.4309 9.90286 11.3536 10.9 11.3536 12.3126ZM18.8121 18.8771C18.8121 17.2983 17.4862 16.5504 16.1602 16.5504H15.9945V21.2868H16.1602C17.7348 21.2868 18.8121 20.2897 18.8121 18.8771Z",
    fill: "#00EC25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.5533C0 7.24383 6.71271 0.513184 15 0.513184C23.2873 0.513184 30 7.24383 30 15.5533C30 23.8627 23.2873 30.5934 15 30.5934C6.71271 30.5934 0 23.8627 0 15.5533ZM1.98897 15.6364C1.98897 22.7825 7.79005 28.6822 15 28.6822C22.21 28.6822 28.011 22.7825 28.011 15.6364C28.011 8.49025 22.1271 2.59055 15 2.59055C7.87293 2.59055 1.98897 8.49025 1.98897 15.6364Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoinGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CoinGreen.3968b3de6b396dbf07e4aa51507075f6.svg";